export const COOKIES = {
  COOKIES_FIELD: 'cookies',
  DISABLED: 'disabled',
  ENABLED: 'enabled',
  EXPIRES_FIELD: 'expires',
};
